/**
 * @author fjornan
 * 业务合伙人相关
 */
import axios from 'axios'
import storage from '../utils/storage'
import * as md5 from '../utils/security/md5'

export default {
  /**
   * 登录账号
   * @param {Object} user 发送对象
   */
  toLogin(user) {
    return new Promise((resolve, reject) => {
      axios
        .post(global.AGENT_LOGIN, user)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 获取用户信息
   * userId 用户id
   */
  getUserInfo(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${global.AGENT}${userId}/info`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 获取用户消息列表
   * userId 用户id indexPage 第几页
   */
  getUserMsg(userId, indexPage) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${global.AGENT}${userId}/msg/${indexPage}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 获取用户邀请列表
   * userId 用户id
   */
  getUserInvite(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${global.AGENT}${userId}/invite`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 获取用户订单列表
   * userId 用户id
   */
  getUserOrder(userId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${global.AGENT}${userId}/order`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 修改密码
   * @param {Object} pwd 发送对象
   */
  changePassword(pwd) {
    return new Promise((resolve, reject) => {
      axios
        .post(global.AGENT_CHANGE_PASSWORD, pwd)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  /**
   * 提现
   * @param {Object} userId
   */
  WithdrawalApi(userId) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${global.WITHDRAW}/agentUserWithdrawal`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  }
}
